import "./src/styles/global.css";
import "@fontsource/source-sans-3";

require("prismjs/themes/prism-solarizedlight.css");
